import { useMemo } from 'react';
import { Column } from 'react-table';
import { NavLink } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { strings } from 'strings';
import { StatusLabel } from 'shared/Components/StatusLabel';
import { Status } from 'shared/enums';
import { capitalize } from 'utilities';
import { errorIconSrc } from 'assets/Icons';
import { Image, Text } from 'shared/Typhography';
import { ActionButtons, Button } from 'shared/Components';

interface Data {
  id: string;
  profileImage: string;
  name: string;
  imagesUploaded: number;
  followers: number;
  username: string;
  revenueShare: number;
  action: () => void;
  status?: string;
  createdAt: number | null;
  requiresInitialApproval?: boolean;
}

export const useArtistTableHeaders = (data: Array<any>) => {
  const { colors } = useTheme();

  return useMemo<Array<Column<Data>>>(
    () => [
      {
        Header: strings.profileImage,
        accessor: 'profileImage',
        Cell: (cell) => (
          <Image
            size="profileImageTable"
            borderRadiusType="rounded"
            loading="lazy"
            src={cell.row.original.profileImage || errorIconSrc}
            alt={cell.row.original.username}
          />
        ),
        width: '5%',
      },
      {
        Header: strings.name,
        accessor: 'name',
      },
      {
        Header: 'Status',
        accessor: 'status',
        Cell: (cell) => {
          const key = capitalize(cell?.row?.original?.status || 'None');
          return <StatusLabel value={Status[key as keyof typeof Status]} />;
        },
      },
      {
        Header: 'Created date',
        accessor: 'createdAt',
        Cell: (cell) => (
          <b>
            {cell?.row?.original?.createdAt
              ? new Date(cell.row.original.createdAt).toLocaleString('en-us', {
                  month: 'short',
                  year: 'numeric',
                  day: 'numeric',
                })
              : '/'}
          </b>
        ),
        width: '10%',
      },
      {
        Header: strings.imagesUploaded,
        accessor: 'imagesUploaded',
      },
      {
        Header: strings.followers,
        accessor: 'followers',
      },
      {
        Header: strings.revenueShare,
        accessor: 'revenueShare',
      },
      {
        Header: strings.displayName,
        accessor: 'username',
        Cell: (cell) => (
          <Text weight="bold" color={colors.purple}>
            {cell.row.original.username}
          </Text>
        ),
        maxWidth: 200,
      },
      {
        Header: strings.action,
        accessor: 'action',
        Cell: (cell) => (
          <ActionButtons onClick={(e) => e.stopPropagation()}>
            <NavLink
              to={
                cell.row.original.requiresInitialApproval
                  ? `/first-approval/${cell.row.original.id}`
                  : `/edit-artist/${cell.row.original.id}`
              }
            >
              {/* Above route edit-puzzle need to be in brackets ENUM but i got some type error Need to be fixed */}
              <Button variant="link">{strings.edit}</Button>
            </NavLink>
            <NavLink to={`/view-artist/${cell.row.original.id}`}>
              {/* Above route edit-puzzle need to be in brackets ENUM but i got some type error Need to be fixed */}
              <Button variant="link">View</Button>
            </NavLink>
            <NavLink to={`/revenue-by-artist/${cell.row.original.id}`}>
              <Button variant="link">Revenue</Button>
            </NavLink>
          </ActionButtons>
        ),
      },
    ],
    [data],
  );
};
